import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LEGALFRACTION,
  DELETE_LEGALFRACTION,
  UPDATE_LEGALFRACTION,
  ADD_NEW_LEGALFRACTION,
} from "./actionType";

import {
  getLegalFractionSuccess,
  getLegalFractionFail,
  deleteLegalFractionSuccess,
  deleteLegalFractionFail,
  updateLegalFractionSuccess,
  updateLegalFractionFail,
  addLegalFractionSuccess,
  addLegalFractionFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getLegalFractionApi,
  updateLegalFractionApi,
  deleteLegalFractionApi,
  addNewLegalFractionApi
} from "../../helpers/backend_helper";

function* getLegalFraction({ payload: legalFraction }) {
  try {
    const response = yield call(getLegalFractionApi, legalFraction);
    yield put(getLegalFractionSuccess(GET_LEGALFRACTION, response.data));
  } catch (error) {
    yield put(getLegalFractionFail(GET_LEGALFRACTION, error));
  }
}

function* onUpdateLegalFraction({ payload: legalFraction }) {
  try {
    const response = yield call(updateLegalFractionApi, legalFraction);
    yield put(updateLegalFractionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateLegalFractionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegalFraction({ payload: legalFraction }) {
  try {
    const response = yield call(deleteLegalFractionApi, legalFraction);
    yield put(deleteLegalFractionSuccess({ legalFraction, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalFractionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegalFraction({ payload: legalFraction }) {
  try {
    const response = yield call(addNewLegalFractionApi, legalFraction);
    yield put(addLegalFractionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalFractionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLegalFraction() {
  yield takeEvery(GET_LEGALFRACTION, getLegalFraction);
}

export function* watchUpdateLegalFraction() {
  yield takeEvery(UPDATE_LEGALFRACTION, onUpdateLegalFraction);
}

export function* watchDeleteLegalFraction() {
  yield takeEvery(DELETE_LEGALFRACTION, onDeleteLegalFraction);
}

export function* watchAddNewLegalFraction() {
  yield takeEvery(ADD_NEW_LEGALFRACTION, onAddNewLegalFraction);
}

function* legalFractionSaga() {
  yield all([
    fork(watchGetLegalFraction),
    fork(watchDeleteLegalFraction),
    fork(watchUpdateLegalFraction),
    fork(watchAddNewLegalFraction)
  ]);
}

export default legalFractionSaga;
